import { Indonesian } from 'flatpickr/dist/l10n/id'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { today } from '@/store/helpers'

export const configFlatPickr = {
  mode: 'single',
  locale: Indonesian,
  altInput: true,
  altFormat: 'j/n/Y',
  dateFormat: 'Y-m-d',
  maxDate: today,
  disableMobile: true,
  plugins: [
    new MonthSelect({
      shorthand: true,
      dateFormat: 'Y-m-d',
      altFormat: 'M Y',
    }),
  ],
}

export const configPieChart = {
  chart: {
    type: 'donut',
  },
  legend: {
    show: true,
    position: 'bottom',
  },
  plotOptions: {
    pie: {
      donut: {
        size: '30%',
      },
    },
  },
}

export const fieldDetailOrder = [
  {
    key: 'no',
    label: 'No',
  },
  {
    key: 'name',
    label: 'Jenis Kendala',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
  {
    key: 'count',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
]

/**
 * Style untuk tiap index jenis kendala (0–3).
 * Digunakan di OrderChart.vue (getClass by index) & OrderDetail.vue (bullet color).
 */
export const PROBLEM_INDEX_STYLES = [
  { class: 'bg-[#FFEAEB]', style: 'border: solid 2px #FFB5B5', bullet: 'bg-[#D6292F]' },
  { class: 'bg-[#FFEED8]', style: 'border: solid 2px #FFD298', bullet: 'bg-[#FF8E00]' },
  { class: 'bg-[#F4ECF9]', style: 'border: solid 2px #C5A3FF', bullet: 'bg-[#5D00FF]' },
  { class: 'bg-[#F2F2F2]', style: 'border: solid 2px #C5C5C5', bullet: 'bg-[#4F4F4F]' },
]

/** Warna bullet per-index untuk tabel detail (OrderDetail.vue) */
export const PROBLEM_BULLET_COLORS = ['bg-[#D6292F]', 'bg-[#FF8E00]', 'bg-[#5D00FF]', 'bg-[#4F4F4F]']

/** Warna jenis kendala berdasarkan index (untuk chart donut di OrderChart.vue) */
export const PROBLEM_INDEX_COLORS = ['#D6292F', '#FF8E00', '#5D00FF', '#4F4F4F']

/**
 * Style card per-ekspedisi untuk tampilan legend chart (OrderChart.vue).
 * Key harus uppercase agar cocok dengan item.name.toUpperCase().
 */
export const EXPEDITION_STYLES = {
  IDEXPRESS: { class: 'bg-[#FFEAEB]', style: 'border: solid 2px #FFB5B5', bullet: 'bg-[#E31A1A]' },
  SICEPAT: { class: 'bg-[#FFF9E5]', style: 'border: solid 2px #FBC02D', bullet: 'bg-[#FBC02D]' },
  SAP: { class: 'bg-[#FFEED8]', style: 'border: solid 2px #FFD298', bullet: 'bg-[#FF8E00]' },
  NINJA: { class: 'bg-[#F4ECF9]', style: 'border: solid 2px #D0B1FF', bullet: 'bg-[#6A1B9A]' },
  JNE: { class: 'bg-[#FFEAEB]', style: 'border: solid 2px #F45D6B', bullet: 'bg-[#A41321]' },
  SPX: { class: 'bg-[#FCD4BE]', style: 'border: solid 2px #FF6A3A', bullet: 'bg-[#FF6A3A]' },
  LION: { class: 'bg-[#FFDBCF]', style: 'border: solid 2px #E28B6E', bullet: 'bg-[#E28B6E]' },
}

/** Fallback style untuk ekspedisi yang tidak ada di EXPEDITION_STYLES */
export const DEFAULT_EXPEDITION_STYLE = { class: 'bg-[#F2F2F2]', style: 'border: solid 2px #B7B7B7', bullet: 'bg-[#616161]' }

/**
 * Warna chart per-ekspedisi (single source of truth, dipakai di OrderChart fetchData).
 * Key uppercase.
 */
export const EXPEDITION_COLORS = {
  IDEXPRESS: '#E31A1A',
  SICEPAT: '#FBC02D',
  SAP: '#FF8E00',
  NINJA: '#6A1B9A',
  JNE: '#A41321',
  'J&T': '#616161',
  SPX: '#FF6A3A',
  LION: '#E28B6E',
}

/**
 * Konfigurasi untuk card metrik sederhana (hanya count + persen, tanpa breakdown).
 * Menggantikan CardDelivery, CardBroken, CardLost.
 * Urutan array = urutan tampil di grid.
 */
export const SIMPLE_CARD_CONFIGS = [
  {
    metric: 'total',
    title: 'Jumlah Pengiriman',
    tooltipText: 'Jumlah orderan yang dibuat di bulan yg dipilih yang berstatus "Dibuat", "Dipacking", "Dikirim", "Diterima", "Retur" (retur dalam perjalanan dan retur selesai), "Hilang", "Rusak” sesuai filter ekspedisi yang dipilih',
    iconClass: 'k-truck',
    iconColor: 'text-[#08A0F7]',
    iconBg: 'bg-[#DFF3FF]',
    showPercent: false,
  },
  {
    metric: 'sent',
    title: 'Orderan Masih Dikirim',
    tooltipText: 'Total order dengan status order "Dikirim" (yang terkena tiket dan tidak terkena tiket) (berdasarkan filter yang dipilih)',
    iconClass: 'k-truck-fast',
    iconColor: 'text-[#D19D04]',
    iconBg: 'bg-[#FEF2CD]',
    showDetails: true,
    detailsConfig: [
      { label: 'Tanpa Kendala', bulletColor: 'bg-[#BBE2C6]' },
      { label: 'Kendala', bulletColor: 'bg-[#FCBEBE]' },
    ],
    showAction: true,
    actionConfig: {
      routeName: 'order-dikirim',
      buttonText: 'Tinjauan Kendala Semua Ekspedisi',
      iconClass: 'k-danger text-[#FBBC05]',
      rightIconClass: 'k-arrow-right-3 text-white',
    },
  },
  {
    metric: 'received',
    title: 'Diterima',
    tooltipText: 'Total order dengan status "Diterima" (baik yang melalui/tidak melalui tiket) (berdasarkan filter yang dipilih)',
    iconClass: 'k-box',
    iconColor: 'text-[#34A853]',
    iconBg: 'bg-[#D6EEDD]',
  },
  {
    metric: 'return',
    title: 'Retur',
    tooltipText: 'Total order dengan status "Retur" (berdasarkan filter yang dipilih)',
    iconClass: 'k-convert-3d-cube',
    iconColor: 'text-[#6D3CB8]',
    iconBg: 'bg-[#E2D8F1]',
    showDetails: true,
    detailsConfig: [
      { label: 'Perjalanan Pulang', bulletColor: 'bg-[#CEBEE7]' },
      { label: 'Retur Diterima', bulletColor: 'bg-[#E2D8F1]' },
    ],
    showAction: true,
    actionConfig: {
      routeName: 'order-retur',
      buttonText: 'Tinjauan Kendala Semua Ekspedisi',
      iconClass: 'k-danger text-[#FBBC05]',
      rightIconClass: 'k-arrow-right-3 text-white',
    },
  },
  {
    metric: 'broken',
    title: 'Paket Rusak',
    tooltipText: 'Total orderan dengan status order "Rusak" (berdasarkan filter yang dipilih)',
    iconClass: 'k-box-remove',
    iconColor: 'text-[#828282]',
    iconBg: 'bg-[#E2E2E2]',
  },
  {
    metric: 'lost',
    title: 'Paket Hilang',
    tooltipText: 'Total orderan dengan status order "Hilang" (berdasarkan filter yang dipilih)',
    iconClass: 'k-box-search',
    iconColor: 'text-[#F8320A]',
    iconBg: 'bg-[#FED6CE]',
  },
]
